import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';

import { theme } from '_constants/theme';
import { hexToRGBA } from '_helpers/theme';

import Spinner from 'components/atomic/Spinner';
import Text from 'components/atomic/layouts/Text';

import UpcomingDatesListItem from './UpcomingDatesListItem';

// eslint-disable-next-line react/display-name, react/prop-types, no-unused-vars
const StyledContainer = styled(forwardRef(({ loading, ...props }, ref) => <div ref={ref} {...props} />))`
  flex-grow: 1;

  padding-top: ${theme.spaces.medium}px;
  padding-right: ${theme.spaces.small}px;

  overflow: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: ${hexToRGBA(theme.colors.gray.secondary, 0.1)} 0% 0% no-repeat padding-box;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${hexToRGBA(theme.colors.gray.secondary, 0.5)} 0% 0% no-repeat padding-box;
    border-radius: 4px;
  }

  ${({ loading }) =>
    loading &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      overflow: unset;
      overflow-x: unset;
      padding-top: 0;
      padding-right: 0;
    `}

  @media ${theme.devices.tablet} {
    max-height: unset;
    overflow: unset;
    overflow-x: unset;

    ${({ loading }) =>
      loading &&
      css`
        padding-top: ${theme.spaces.medium}px;
      `}
  }
`;

const UpcomingDatesList = ({ loading, items = [] }) => {
  if (loading) {
    return (
      <StyledContainer loading>
        <Spinner />
      </StyledContainer>
    );
  }

  if (!items.length) {
    return (
      <StyledContainer loading>
        <Text size={theme.fontSizes.small} weight={400} color={theme.colors.gray.primary} centered>
          No data available
        </Text>
      </StyledContainer>
    );
  }

  return (
    <StyledContainer>
      {items.map(({ id, ...restItem }) => (
        <UpcomingDatesListItem key={id} {...restItem} />
      ))}
    </StyledContainer>
  );
};

UpcomingDatesList.propTypes = {
  loading: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      month: PropTypes.number,
      day: PropTypes.number,
      description: PropTypes.string,
    })
  ),
};

export default UpcomingDatesList;
